module.exports = __webpack_public_path__ + "img/header-diamondJewelryRedgold@2x.8e89572.webp";